
import LocalManager from './LocalManager';

const UserToken = ()=>{   
    return  LocalManager.getItem('session')
};

export default UserToken;